// src/styles/theme.js
import { extendTheme } from '@chakra-ui/react';
import { colors } from './colors';

const config = {
    initialColorMode: 'dark',
    useSystemColorMode: false,
};

const styles = {
    global: {
        body: {
            bg: colors.background,
            color: colors.white,
        },
        '*': {
            fontFamily: `'Plus Jakarta Sans', sans-serif`,
        }
    }
};

const fonts = {
    heading: `'Plus Jakarta Sans', sans-serif`,
    body: `'Plus Jakarta Sans', sans-serif`,
};

const components = {
    Button: {
        baseStyle: {
            borderRadius: 'lg',
        },
        variants: {
            solid: {
                bg: colors.secondary,
                color: colors.primary,
                _hover: {
                    bg: '#02d066',
                },
            },
        },
    },
    Input: {
        baseStyle: {
            field: {
                bg: colors.surface,
                color: colors.white,
                borderColor: colors.secondary,
                _placeholder: {
                    color: colors.gray[400],
                },
            },
        },
    },
};

export default extendTheme({
    config,
    styles,
    colors,
    fonts,
    components,
});
